import { render, staticRenderFns } from "./PodcastSkeletonLoader.vue?vue&type=template&id=08ba47e4&scoped=true"
import script from "./PodcastSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./PodcastSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./PodcastSkeletonLoader.vue?vue&type=style&index=0&id=08ba47e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba47e4",
  null
  
)

export default component.exports